(function () {
    'use strict';

    angular.module('app').controller('PointsOfSalesController', PointsOfSalesController);

    PointsOfSalesController.$inject = [
        '$rootScope',
        '$scope',
        '$route',
        '$routeParams',
        '$location',
        '$timeout',
        '$filter',
        'uiGmapGoogleMapApi',
        '$uibModal',
        'blockUI',
        'NotifyService',
        'POSService',
        'TerminalService',
        'LANGS',
        'SelectService',
        'FeedbackService',
        'LoyaltyService',
        'ShortenerService',
        'SettingsService'
    ];

    function PointsOfSalesController(
        $rootScope,
        $scope,
        $route,
        $routeParams,
        $location,
        $timeout,
        $filter,
        GoogleMapApi,
        $uibModal,
        blockUI,
        NotifyService,
        POSService,
        TerminalService,
        LANGS,
        SelectService,
        FeedbackService,
        LoyaltyService,
        ShortenerService,
        SettingsService
    ) {

        var isRoadTankersMode = !!$route.current.$$route.isRoadTankersMode;
        $scope.isRoadTankersMode = isRoadTankersMode;

        $scope.isInCust = appConfig.platformParams.main_site.en === 'incust.com';
        $scope.isPageMode = isPageMode;
        $scope.support_pos_priority = !!$rootScope.ENV.business.support_pos_priority;
        $scope.getLoyaltiesList = SelectService.getLoyaltiesList;
        $scope.getCountriesList = SelectService.getCountriesList;
        $scope.getTimezonesList = SelectService.getTimezonesList;
        $scope.multiLang = MultilanguageHelper();
        $scope.multiLangInvitationMessageToPrint = MultilanguageHelper();
        $scope.multiLangInvitationMessageTextnot = MultilanguageHelper();
        $scope.onChangeLanguage = onChangeLanguage;
        $scope.onMultiLangInvitationMessageToPrint = onMultiLangInvitationMessageToPrint;
        $scope.onMultiLangInvitationMessageText = onMultiLangInvitationMessageText;
        $scope.getLocalizeField = getLocalizeField;
        $scope.getPages = getTotalPaginatedPages;
        $scope.onPOSSave = onPOSSave;
        $scope.onPOSPublish = onPOSPublish;
        $scope.onPOSChildSaveOrRemove = onPOSChildSaveOrRemove;

        $scope.model = {
            posFeedback: {},
            possibilityPrintFeedbackOnCheck: false,
        };
        $scope.modal = {};
        $scope.pos_type = {
            POS: 'pos',
            ONLINE_STORE: 'online-store',
            ROAD_TANKER: 'road-tanker'
        };
        $scope.data = {
            currentTab: 'general',
            showOnlineStore: false,

            posImage: {
                src: '',
                cropped: '',
                new: false,
                delete: false,
                loading: false
            },

            pagers: [10, 20, 50, 100, 200],

            printFeedbackSourceOnCheckTypes: [
                {value: 'qr-code', title: 'qr-code print'},
                {value: 'url', title: 'url print'},
                {value: 'all', title: 'all print'}
            ],
            invitationMessageTypes: [
                {value: 'push-chatbot-sms', title: 'TEXT_PUSH_CHATBOT_VIBER_SMS'},
                {value: 'push-chatbot-viber', title: 'TEXT_PUSH_CHATBOT_VIBER'},
                {value: 'push-chatbot', title: 'TEXT_PUSH_CHATBOT'},
                {value: 'viber-sms', title: 'TEXT_VIBER_SMS'},
                {value: 'push', title: 'TEXT_PUSH'},
                {value: 'chatbot', title: 'TEXT_CHATBOT'},
                // {value: 'viber', title: 'TEXT_VIBER'},
                {value: 'sms', title: 'TEXT_SMS'},
                {value: 'email', title: 'TEXT_EMAIL'},
                {value: 'external-system', title: 'TEXT_EXTERNAL_SYSTEM'}
            ],
            loyaltyLinks: [
                {type: 'web', title: 'Web site', icon: 'fa-home'},
                {type: 'email', title: 'Email', icon: 'fa-envelope'},
                {type: 'facebook', title: 'Facebook', icon: 'fa-facebook-official'},
                {type: 'youtube', title: 'Youtube', icon: 'fa-youtube'},
                {type: 'twitter', title: 'Twitter', icon: 'fa-twitter-square'},
                {type: 'tiktok', title: 'TikTok', icon: 'fa-tiktok'},
                {type: 'linkedin', title: 'LinkeIn', icon: 'fa-linkedin'},
                {type: 'telegram', title: 'Telegram', icon: 'fa-telegram'},
                {type: 'instagram', title: 'Instagram', icon: 'fa-instagram'},
                {type: 'pinterest', title: 'Pinterest', icon: 'fa-pinterest'},
                {type: 'vk', title: 'VK', icon: 'fa-vk'}
            ],
            type_of_pos: [
                {
                    value: isRoadTankersMode ? $scope.pos_type.ROAD_TANKER : $scope.pos_type.POS,
                    title: isRoadTankersMode ? 'pos_type_road-tanker' : 'pos_type_pos'
                }
            ],
            check_item_enter_mode_type_of_pos: [
                {
                    value: 'without-limits',
                    title: 'pos_check_item_enter_mode_without-limits'
                },
                {
                    value: 'presets-only',
                    title: 'pos_check_item_enter_mode_presets-only'
                },
                {
                    value: 'manually-only',
                    title: 'pos_check_item_enter_mode_manually-only'
                },

            ],
            order_type_of_online_store: [
                {
                    value: 'online-store',
                    title: 'online_store#order_type#online-store'
                },
                {
                    value: 'fuel-taxi',
                    title: 'online_store#order_type#fuel-taxi'
                }
            ],
            payment_type_of_online_store: [
                {
                    value: 'none',
                    title: 'Do not accept payment'
                },
                {
                    value: 'required',
                    title: 'Payment required'
                },
                {
                    value: 'bonuses',
                    title: 'Payment by bonuses only'
                },
                {
                    value: 'possible',
                    title: 'Payment is possible'
                }
            ],
            transaction_type_of_online_store: [
                {
                    value: 'sale',
                    title: 'online_store#transaction_type#sale'
                },
                {
                    value: 'reserve',
                    title: 'online_store#transaction_type#reserve'
                },
                {
                    value: 'authorize-payment',
                    title: 'online_store#transaction_type#authorize-payment'
                }
            ],
            notify_by_email: 'No'
        };

        if (!isRoadTankersMode) {
            $scope.data.type_of_pos.push({value: $scope.pos_type.ONLINE_STORE, title: 'pos_type_online-store'});
        }
        var block_pos_list = blockUI.instances.get('pos_list');
        var block_pos_edit = blockUI.instances.get('pos_edit');

        var oldPulicationState = null;

        $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
        SettingsService.GetPlatformSupportedLanguages(function (success, response) {
            $scope.platformSupportedLanguagesCodes = response;
        });

        initController();

        var unbindTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
            $scope.getCountriesList();
        });

        $scope.$on('$destroy', unbindTranslateChangeSuccess);

        function isPageMode(mode) {
            return mode == $scope._pageMode;
        }

        $scope.onSelect = function () {
            if ($scope.model.posOnlineStore.order_type === 'fuel-taxi') {
                $scope.model.posOnlineStore.transaction_type = $scope.data.transaction_type_of_online_store[2].value;
            }
        };

        $scope.getPosPricePreviewLink = function (pos_id, type) {
            return `${appConfig.workers.preview}/pos/${pos_id}/${type}`;
        }

        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        function initPageMode() {
            $scope._pageMode = 'show';

            if (isRouteMode('edit')) {
                if ($routeParams['tab'] && $routeParams['tab'] != 'general')
                    $scope.data.currentTab = $routeParams['tab'];

                $scope._pageMode = ($routeParams.hasOwnProperty('pos_id')) ? 'edit' : 'show';
            } else if (isRouteMode('create')) {
                $scope._pageMode = 'create';
            }

            getPOSFeedbackSettings($routeParams.pos_id);

            switch ($scope._pageMode) {
                case 'show':
                    _doShow();
                    break;
                case 'create':
                    _doCreate();
                    break;
                case 'edit':
                    _doEdit();
                    break;
            }
        }

        $scope.selectPosType = function (model) {
            $scope.data.showOnlineStore = (model === $scope.pos_type.ONLINE_STORE);
            if ($scope.data.showOnlineStore) {
                if (!$scope.data.posList) {
                    getPOS();
                }
                // if(!$scope.model.posOnlineStore) {
                //     $scope.model.posOnlineStore = {
                //         order_type: $scope.data.order_type_of_online_store[0].value,
                //         transaction_type: $scope.data.transaction_type_of_online_store[0].value,
                //        // TODO  payment_type: $scope.data.transaction_type_of_online_store[0].value,
                //         terminal_id: null,
                //     }
                // }
            }
        };

        function initmultiLang() {
            $scope.multiLang.initLangs(LANGS, $rootScope.LANG);
            $scope.multiLangInvitationMessageToPrint.initLangs(LANGS, $rootScope.LANG);
            $scope.multiLangInvitationMessageTextnot.initLangs(LANGS, $rootScope.LANG);
        }

        function initController() {
            initmultiLang();
            initPageMode();
        }

        function onChangeLanguage(new_lang) {
            $scope.multiLang.selected(new_lang);
        };

        function onMultiLangInvitationMessageToPrint(new_lang) {
            $scope.multiLangInvitationMessageToPrint.selected(new_lang);
        };

        function onMultiLangInvitationMessageText(new_lang) {
            $scope.multiLangInvitationMessageTextnot.selected(new_lang);
        };

        function initLocaleStrings(pos) {
            $scope.multiLang.initStrings(pos, ['public_title', 'public_description', 'addresses']);
        }

        function initLocaleStringsForFeedbackSettings(posFeedbackSettings) {
            $scope.multiLangInvitationMessageToPrint.initStrings(posFeedbackSettings, ['print_feedback_on_check_message_text']);
            $scope.multiLangInvitationMessageTextnot.initStrings(posFeedbackSettings, ['transaction_feedback_message_text']);
            if (posFeedbackSettings.print_feedback_on_check !== "none") {
                $scope.model.possibilityPrintFeedbackOnCheck = true;
            }
        }

        function _doShow() {
            $rootScope.POS = null;
            getPOS();
        }

        function getPOS() {
            block_pos_list.start();

            POSService.All({pos_type: 'all'}, function (success, response) {
                if (success) {
                    var posList = response;/*.filter(function (pos) {
                        return isRoadTankersMode ? pos.type === 'road-tanker' : pos.type !== 'road-tanker'
                    });*/

                    console.log('posList', posList);
                    $scope.data.posList = posList;
                    if ($scope.model.pos_children) {
                        angular.forEach($scope.data.posList, function (pos) {
                            pos.hasParent = $scope.model.pos_children.some(function (pos_child) {
                                return pos.id === pos_child.id;
                            });
                        });
                    }
                }
                block_pos_list.stop();
            });
        }

        function loadTerminalsByLoyaltyId(posId, callback) {
            TerminalService.All(function (success, data) {
                if (success) {
                    $scope.loyaltyTerminals = [];
                    data.forEach(function (item) {
                        if (posId == item.pos_id && item.active == 1) {
                            $scope.loyaltyTerminals.push(item);
                        }
                    });
                    console.log('TERMINALS', $scope.loyaltyTerminals);
                }
                if (callback) {
                    callback();
                }

            });
        }

        function getFeedbackSources(loyaltyId) {
            FeedbackService.getFeedbackSources(loyaltyId, {
                page: 1,
                count: 20,
                only_active: false
            }, function (success, response) {
                if (success) {
                    $scope.data.feedbackSourcesList = response.data;
                    if ($scope.data.feedbackSourcesList && $scope.data.feedbackSourcesList.length && $scope._pageMode === 'create') {
                        $scope.model.posFeedback.active = 1;
                        if (!$scope.$$phase) {
                            $scope.$digest();
                        }
                    }
                }
            });
        }

        $scope.OnChangePossibilityPrintFeedbackOnCheck = function () {
            console.log($scope.model.possibilityPrintFeedbackOnCheck)
            if (!$scope.model.possibilityPrintFeedbackOnCheck) {
                $scope.model.posFeedback.print_feedback_on_check = "none";
            } else {
                $scope.model.posFeedback.print_feedback_on_check = "qr-code";
            }
        };

        function getPosOnlineStore(pos_id) {
            if (!pos_id) {
                return;
            }
            POSService.GetOnlineStore(pos_id, function (success, data) {
                if (success) {
                    $scope.model.posOnlineStore = angular.copy(data);
                    $scope.notification_emails = angular.copy(data.notification_emails) || [];
                    if ($scope.notification_emails.length > 0) {
                        $scope.data.notify_by_email = 'Yes';
                    } else {
                        $scope.data.notify_by_email = 'No';
                    }
                }
            });
        }

        function getPOSFeedbackSettings(pos_id) {
            if (!pos_id) {
                return;
            }

            FeedbackService.getFeedbackPOSSettings(pos_id, function (success, response) {
                if (success) {
                    $scope.model.posFeedback = response;
                    initLocaleStringsForFeedbackSettings($scope.model.posFeedback);
                }
            });
        }

        $scope.isItemFiltered = function (pos) {
            if ($scope.data.currentLoyalty)
                return $scope.data.currentLoyalty.id === '0' ? true : (pos.loyalty_id === $scope.data.currentLoyalty.id ? true : false);
            else
                return true;
        };

        $scope.isLoyaltyActive = function (loyalty_id) {
            var l = null;
            if ($rootScope.LOYALTIES) {
                l = itemByIndex($rootScope.LOYALTIES, loyalty_id);

                return l && l.active;
            }

            return true;
        };

        $scope.validation = function (link) {
            if (!link.url) link.error = $translate.instant('LINK_VALIDATION_ERROR');
            else link.error = '';
        };

        $scope.onPOSToggleClick = function (pos) {
            block_pos_list.start();
            var post_data = {
                id: pos.id,
                country: pos.country,
                active: 1 * !Boolean(pos.active)
            };

            POSService.Change(pos.id, post_data, function (success, response) {
                if (success) {
                    $rootScope.POS = null;
                    getPOS();

                    // var l = $rootScope.POS;
                    // for (var i in l)
                    //     if (l[i].id === post_data.id)
                    //         l[i].active = post_data.active;
                }
                block_pos_list.stop();
            });
        };

        $scope.onPkpassEditClick = function (pos) {
            $uibModal.open({
                templateUrl: 'app/pages/pos/modals/modal.pkpass.html',
                animation: true,
                keyboard: true,
                size: 'md',
                backdrop: 'static',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    var pkpass_modal = blockUI.instances.get('pkpass_modal');
                    popup.qrCodeLink = '';
                    popup.cardTypes = [
                        {
                            type: 'digital',
                            title: 'pos#pkpass#add_card_type_digital'
                        },
                        {
                            type: 'plastic',
                            title: 'pos#pkpass#add_card_type_plastic'
                        }
                    ];
                    popup.cardType = popup.cardTypes[0];
                    popup.authPhone = false;
                    popup.link = getLink(popup.cardType.type, popup.authPhone);

                    ShortenerService.Create(popup.link, function (success, response) {
                        if (!success) {
                            popup.qrCodeLink = popup.link;
                            return;
                        }
                        popup.qrCodeLink = response.url;
                    });

                    popup.onSelectCardType = function () {
                        pkpass_modal.start();
                        popup.link = getLink(popup.cardType.type, popup.authPhone);
                        ShortenerService.Create(popup.link, function (success, response) {
                            if (!success) {
                                popup.qrCodeLink = popup.link;
                                return;
                            }
                            popup.qrCodeLink = response.url;
                            pkpass_modal.stop();
                        });
                    };

                    popup.onCancelClick = function () {
                        $uibModalInstance.close();
                    };

                    popup.onCopyLink = function () {
                        $uibModalInstance.close();
                    };

                    function getLink(type, authPhone) {
                        var domain = 'https://' + (appConfig.platformParams.client_site[$rootScope.LANG] || appConfig.platformParams.client_site.en);
                        if (type === 'plastic') {
                            domain = domain + '/pkpass/pos/' + pos.id + '/new?lang=' + $rootScope.LANG;
                        }
                        if (type === 'digital') {
                            domain = domain + '/pkpass/pos/' + pos.id + '/uid?lang=' + $rootScope.LANG;
                        }
                        domain = domain + `&auth_phone_only=${authPhone || false}`
                        return domain
                    }
                }
            });
        };

        $scope.onPublishStatusRefresh = function (pos_id) {
            POSService.Get(pos_id, function (success, response) {
                if (success)
                    updateItemInList($rootScope.POS, response);
            });
        };

        function getLoyaltyCategories(callback) {
            LoyaltyService.LoyaltyCategories(function (success, data) {
                if (success)
                    $scope.loyalty_categories = $rootScope.LOYALTY_CATEGORIES[$rootScope.LANG];

                callback(true);
            });
        }

        function initNewPos() {
            $scope.model.new_pos = {
                country: $rootScope.ENV.business.country,
                catalog_publication_state: 'none',
                time_zone: 'GMT',
                type: isRoadTankersMode ? 'road-tanker' : 'pos'
            };

            if ($rootScope.COUNTRIES[$rootScope.LANG] && $rootScope.TIMEZONES[$rootScope.LANG]) {
                var pos_country = itemByIndex($rootScope.COUNTRIES[$rootScope.LANG], $scope.model.new_pos.country);
                if (pos_country) {
                    $scope.model.new_pos.time_zone = itemByIndex($rootScope.TIMEZONES[$rootScope.LANG], pos_country.time_zone).id;
                }
            }

            if ($routeParams['lid']) {
                $scope.model.new_pos.loyalty_id = $routeParams['lid'];
                $scope.data.currentLoyalty = itemByIndex($scope.data.loyaltiesList, $scope.model.new_pos.loyalty_id);
            } else if ($scope.data.currentLoyalty) {
                $scope.model.new_pos.loyalty_id = $scope.data.currentLoyalty.id;
            }

            $scope.model.pos = angular.copy($scope.model.new_pos);
        }

        function _doCreate() {
            getLoyaltyCategories(function (success) {
            });

            initNewPos();
            initMap();

            initLocaleStrings($scope.model.pos);
            initLocaleStringsForFeedbackSettings($scope.model.posFeedback);
            $timeout(function () {
                initValues();
            }, 0);
        }

        function initValues() {
            $scope.model.posFeedback.transaction_feedback_message_type = $scope.model.posFeedback.transaction_feedback_message_type
                ? $scope.model.posFeedback.transaction_feedback_message_type
                : 'push-chatbot-viber-sms';
        }

        function getReferences() {
            POSService.GetReferences($routeParams.pos_id, function (success, data) {

                if (success) {
                    $scope.model.pos_children = data.order_processing.children;
                    if (!$scope.data.posList) {
                        $rootScope.POS = null;
                        getPOS();
                    }
                }
            });

        }

        function _doEdit() {
            block_pos_edit.start();

            POSService.Get($routeParams.pos_id, function (success, data) {

                if (success) {
                    $scope.model.pos = angular.copy(data);
                    $scope.data.showOnlineStore = $scope.model.pos.type === $scope.pos_type.ONLINE_STORE;
                    console.log('$scope.model.pos', $scope.model.pos);

                    SelectService.getLoyaltiesList(function (success, response) {
                        $scope.data.currentLoyalty = itemByIndex(response, $scope.model.pos.loyalty_id);
                    });

                    for (var i in $scope.model.pos.links) {
                        for (var k in $scope.data.loyaltyLinks) {
                            if (i === $scope.data.loyaltyLinks[k].type) {
                                $scope.data.loyaltyLinks[k].url = $scope.model.pos.links[i];
                                $scope.data.loyaltyLinks[k].used = true;
                            }
                        }
                    }
                    getFeedbackSources($scope.model.pos.loyalty_id);
                    if ($scope.data.showOnlineStore) {
                        getPosOnlineStore($routeParams.pos_id);
                    }

                    loadTerminalsByLoyaltyId($routeParams.pos_id);
                    // getPosOnlineStore($scope.model.pos.id);

                    getLoyaltyCategories(function (success) {
                        for (var i in $scope.loyalty_categories)
                            for (var k in $scope.model.pos.categories)
                                if ($scope.model.pos.categories[k].id === $scope.loyalty_categories[i].id)
                                    $scope.model.pos.categories[k] = $scope.loyalty_categories[i];
                    });
                    getReferences();
                    if (!$scope.model.catalog_publication_state || $scope.model.catalog_publication_state == '')
                        $scope.model.catalog_publication_state = 'none';

                    initMap();
                    initLocaleStrings($scope.model.pos);
                    $timeout(function () {
                        initValues();
                    }, 0);

                } else {
                    if (isRoadTankersMode) {
                        $location.path('/road-tankers');
                    } else {
                        $location.path('/pos');
                    }

                }
                block_pos_edit.stop();
            });

        }

        $scope.getUnusedLinks = function () {
            var r = [],
                l = $scope.data.loyaltyLinks;

            for (var i in l)
                if (!l[i].used)
                    r.push(l[i]);

            return r;
        };

        $scope.onAddLink = function (link) {
            var l = $scope.data.loyaltyLinks;

            for (var i in l)
                if (l[i].type === link.type)
                    l[i].used = true;
        };

        $scope.onRemoveLink = function (link) {
            var l = $scope.data.loyaltyLinks;

            for (var i in l)
                if (l[i].type === link.type)
                    l[i].used = false;
        };

        function initMap() {
            GoogleMapApi.then(function (maps) {
                maps.visualRefresh = true;
            });

            $scope.marker = {
                id: 0,
                coords: ($scope.model.pos.latitude && $scope.model.pos.longitude) ? {
                    latitude: $scope.model.pos.latitude,
                    longitude: $scope.model.pos.longitude
                } : null,
                options: {
                    draggable: true
                },
                events: {
                    dragend: function (marker, eventName, args) {
                        $scope.model.pos.latitude = marker.getPosition().lat();
                        $scope.model.pos.longitude = marker.getPosition().lng();

                        console.info('dragend marker');
                    }
                }
            };

            var centerMap = $scope.marker.coords;
            if (!centerMap) {
                centerMap = {
                    latitude: 50.4454,
                    longitude: 30.5212
                };

                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        centerMap = {
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude
                        };
                        $scope.map.center = centerMap;
                    });
                }
            }

            angular.extend($scope, {
                map: {
                    center: centerMap,
                    events: {
                        click: function (mapModel, eventName, originalEventArgs) {
                            var e = originalEventArgs[0];
                            $scope.marker.coords = {
                                latitude: e.latLng.lat(),
                                longitude: e.latLng.lng()
                            };

                            $scope.model.pos.latitude = $scope.marker.coords.latitude;
                            $scope.model.pos.longitude = $scope.marker.coords.longitude;

                            console.info('click on map', $scope.marker.coords);
                            $scope.$evalAsync();
                        }
                    },
                    zoom: 14,
                    options: {
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        mapTypeControl: false,
                        mapTypeControlOptions: {
                            style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
                            position: google.maps.ControlPosition.BOTTOM_CENTER
                        },
                        minZoom: 2,
                        maxZoom: 18,
                        panControlOptions: {
                            position: google.maps.ControlPosition.RIGHT_BOTTOM
                        },
                        panControl: true,
                        zoomControl: true,
                        scaleControl: false,
                        streetViewControl: false,
                        overviewMapControl: false,
                        scrollwheel: true
                    }
                },
                searchbox: {
                    template: 'app/pages/pos/searchbox.tpl.html',
                    options: {autocomplete: true, position: 'TOP_RIGHT'},
                    events: {
                        places_changed: function (autocomplete) {
                            console.info('autocomplete', autocomplete);
                            var places = autocomplete.getPlaces();

                            if (places.length == 0) {
                                return;
                            }

                            places.forEach(function (place) {
                                if (place.address_components) {
                                    console.info('place', place);
                                    var bounds = new google.maps.LatLngBounds();

                                    bounds.extend(place.geometry.location);

                                    $scope.marker.coords = {
                                        latitude: place.geometry.location.lat(),
                                        longitude: place.geometry.location.lng()
                                    };

                                    $scope.model.pos.latitude = $scope.marker.coords.latitude;
                                    $scope.model.pos.longitude = $scope.marker.coords.longitude;

                                    $scope.map.bounds = {
                                        northeast: {
                                            latitude: bounds.getNorthEast().lat(),
                                            longitude: bounds.getNorthEast().lng()
                                        },
                                        southwest: {
                                            latitude: bounds.getSouthWest().lat(),
                                            longitude: bounds.getSouthWest().lng()
                                        }
                                    };
                                }
                            });
                            $scope.$evalAsync();
                            console.info('$evalAsync');
                        }
                    }
                }
            });
        }

        $scope.getCoords = function () {
            return ($scope.model.pos && $scope.model.pos.latitude && $scope.model.pos.longitude) ? $filter('number')($scope.model.pos.latitude,
                6) + ';' + $filter('number')($scope.model.pos.longitude, 6) : '-';
        };

        $scope.setMainForm = function (form) {
            $scope.data.formMain = form;
        };

        $scope.setDefaultValue = function (data) {
            if (!data && !!$scope.model.pos) {
                $scope.model.pos.title = '';
            }
        };

        $scope.setPublishForm = function (form) {
            $scope.data.formPublish = form;
        };
        $scope.setOnlineStoreForm = function (form) {
            $scope.data.formOnlineStore = form;
        };

        $scope.onCancelEdit = function () {
            if (isRoadTankersMode) {
                $location.path('/road-tankers');
            } else {
                $location.path('/pos');
            }
        };

        $scope.onChangeTab = function (tab) {
            console.info('TAB', tab);

            var form;

            switch ($scope.data.currentTab) {
                case 'general':
                    form = $scope.data.formMain;
                    break;
                case 'publish':
                    form = $scope.data.formPublish;
                    break;
                case 'online-store':
                    form = $scope.data.formOnlineStore;

                    break;
            }

            if (form) {
                if (form.$dirty || (form.$invalid && $scope.data.currentTab === 'general')) {
                    confirmationPopup(form, tab);
                } else {
                    $scope.data.currentTab = tab;
                    $location.search('tab', tab);
                }
            } else if (!form && $scope.data.currentTab === 'publish') {
                $scope.data.currentTab = tab;
                $location.search('tab', tab);
            } else if (!form && $scope.data.currentTab === 'online-store') {
                $scope.data.currentTab = tab;
                $location.search('tab', tab);
            }
        };

        function confirmationPopup(form, tab) {
            return $scope.modal.confirmation = $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'sm',
                templateUrl: 'app/templates/modal.confirmation.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.type = 'pos';

                    popup.onSaveClick = function (exit) {
                        if (form.$valid) {

                            $scope.data.currentTab = tab;
                            $location.search('tab', tab);

                            if ($scope._pageMode === 'create')
                                onPOSSave(form, false, true);
                            else
                                onPOSSave(form, false, false);
                        } else {
                            isFormValid(form);
                        }

                        $uibModalInstance.close();
                    };

                    popup.onCancelClick = function (exit) {
                        isFormValid(form);

                        if ($scope._pageMode === 'create') {
                            $scope.data.currentTab = 'general';
                        } else {

                            $scope.data.currentTab = tab;
                            $location.search('tab', tab);

                        }

                        $uibModalInstance.close();
                    };
                }
            });
        }

        $scope.onPOSOnlineStoreSave = onPOSOnlineStoreSave;

        function onPOSOnlineStoreSave(form, closeOnSave, redirectToPublish) {
            console.log('onPOSOnlineStoreSave', form);
            if (!isFormValid(form)) {
                return;
            }

            block_pos_edit.start();
            var posId = $routeParams.pos_id;
            savePOSOnlineStore(posId, function (success, response) {
                if (success) {
                    $scope.model.posOnlineStore = angular.copy(response);
                    $scope.notification_emails = angular.copy(response.notification_emails) || [];
                    if ($scope.notification_emails.length > 0) {
                        $scope.data.notify_by_email = 'Yes';
                    } else {
                        $scope.data.notify_by_email = 'No';
                    }
                    if (redirectToPublish) {
                        if (isRoadTankersMode) {
                            $location.path('/road-tankers/edit/' + posId).search('tab', 'publish');
                        } else {
                            $location.path('/pos/edit/' + posId).search('tab', 'publish');
                        }

                        $scope.data.currentTab = 'publish';
                    }
                    if (closeOnSave) {
                        if (isRoadTankersMode) {
                            $location.path('/road-tankers');
                        } else {
                            $location.path('/pos');
                        }

                    }
                    NotifyService.Success(response.message, false);

                }
                block_pos_edit.stop();
            });

            function savePOSOnlineStore(pos_id, callback) {
                POSService.UpdateOnlineStore(pos_id, $scope.model.posOnlineStore, function (success, response) {

                    if (callback) {
                        callback(success, response);
                    }
                });
            }
        }

        $scope.deletePosPhoto = function () {
            if ($scope.data.posImage.new) {
                $scope.data.posImage.new = false;
                $scope.data.posImage.src = '';
            } else if ($scope.model.pos.photos && $scope.model.pos.photos.length > 0) {
                delete $scope.model.pos.photos;
                $scope.data.posImage.delete = true;
            }
        };

        $scope.cropPosPhoto = function () {
            $uibModal.open({
                animation: false,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/templates/modal.crop-image.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-full',
                controller: function ($uibModalInstance) {
                    var popup_crop = this;
                    popup_crop.image = angular.copy($scope.data.posImage);

                    popup_crop.onCancelClick = function () {
                        $uibModalInstance.close();
                    }

                    popup_crop.onCropImage = function () {
                        $scope.data.posImage = angular.copy(popup_crop.image);
                        $uibModalInstance.close();
                    }
                }
            })
        };

        function onPOSSave(form, closeOnSave, redirectToPublish) {
            block_pos_edit.start();

            function handleResult(success, response) {
                if (success) {
                    form.$dirty = false;
                    // if( $scope.data.showOnlineStore) {
                    //     savePOSOnlineStore(response, $routeParams.pos_id || response.id, function() {
                    //         savePOSFeedbackSettings(response, $routeParams.pos_id || response.id);
                    //     })
                    // } else {
                    savePOSFeedbackSettings(response, $routeParams.pos_id || response.id);
                    // }

                } else {
                    block_pos_edit.stop();
                    if (oldPulicationState) {
                        $scope.model.pos.catalog_publication_state = oldPulicationState;
                        oldPulicationState = null;
                    }
                    NotifyService.Error($filter('translate')('POS isn\'t saved!') + '<br/>' + response.message);
                }

            }

            function savePOSFeedbackSettings(res, pos_id) {

                if (!pos_id) {
                    block_pos_edit.stop();
                    return;
                }
                FeedbackService.changeFeedbackPOSSettings(pos_id, $scope.model.posFeedback, function (success, response) {
                    if (success) {
                        if ($scope.data.posImage.delete && !$scope.data.posImage.new) {
                            POSService.DeletePhoto(res.id, function (success, response) {
                                if (success) {
                                    if (res.photos && res.photos[0]) {
                                        delete res.photos[0];
                                    }
                                }
                                $scope.model.pos = res;
                                $scope.data.posImage.delete = false;
                                updateItemInList($rootScope.POS, res);
                            });
                        } else if ($scope.data.posImage.new) {
                            var image = $scope.data.posImage.cropped || $scope.data.posImage.src;
                            POSService.UploadPhoto(res.id, image, function (success, upload_response) {
                                if (success) {
                                    if (res.photos && res.photos[0])
                                        res.photos[0] = upload_response;
                                    else
                                        res.photos = [{'id': upload_response.id, 'url': upload_response.url}];

                                    // res.photos[0] = upload_response;
                                    $scope.data.posImage.new = false;
                                    $scope.data.posImage.delete = false;
                                    $scope.data.posImage.src = '';
                                    $scope.model.pos = res;
                                }
                                updateItemInList($rootScope.POS, res);
                            });
                        } else {
                            $scope.model.pos = res;
                            updateItemInList($rootScope.POS, res);
                        }

                        if (redirectToPublish) {
                            if (isRoadTankersMode) {
                                $location.path('/road-tankers/edit/' + res.id).search('tab', 'publish');
                            } else {
                                $location.path('/pos/edit/' + res.id).search('tab', 'publish');
                            }

                            $scope.data.currentTab = 'publish';
                        }
                        if (closeOnSave) {
                            if (isRoadTankersMode) {
                                $location.path('/road-tankers');
                            } else {
                                $location.path('/pos');
                            }

                        }
                    }
                    block_pos_edit.stop();
                });
            }

            if (isFormValid(form)) {

                var post_data = angular.copy($scope.model.pos);

                post_data = cleanRequestData(post_data);
                post_data.loyalty_id = $scope.data.currentLoyalty.id;
                post_data.links = {};
                post_data.links = {};

                for (var i in $scope.data.loyaltyLinks) {
                    var l = $scope.data.loyaltyLinks[i];

                    if (l.used)
                        post_data.links[l.type] = l.url;
                }
                for (var i in post_data.categories) {
                    delete post_data.categories[i].title;
                    delete post_data.categories[i].image_url;
                }
                switch ($scope._pageMode) {
                    case 'create':
                        POSService.Create(post_data, handleResult);
                        break;
                    case 'edit':
                        POSService.Change(post_data.id, post_data, handleResult);
                        break;
                    default:

                }
            } else {
                block_pos_edit.stop();
            }
        }

        function onPOSPublish(form, type) {
            if (isFormValid(form)) {
                var ns = $scope.model.pos.catalog_publication_state;

                switch (type) {
                    case 'save':
                        ns = $scope.model.pos.catalog_publication_state;
                        break;
                    case 'publish':
                        ns = 'requested';
                        break;
                    case 'unpublish':
                        ns = 'none';
                        break;
                    case 'save-and-publish':
                        ns = $scope.model.pos.catalog_publication_state == 'allowed' ? 'allowed' : 'requested';
                        break;
                }

                if ($scope.model.pos.catalog_publication_state != ns) {
                    oldPulicationState = $scope.model.pos.catalog_publication_state;
                    $scope.model.pos.catalog_publication_state = ns;
                }

                onPOSSave(form, false, false);
            }
        }

        function onPOSChildSaveOrRemove(form, child_pos, remove) {
            block_pos_edit.start();

            function handleResult(success, response) {
                if (success) {
                    $scope.model.pos_children = response.order_processing.children;
                    if ($scope.model.pos_children) {
                        angular.forEach($scope.data.posList, function (pos) {
                            pos.hasParent = $scope.model.pos_children.some(function (pos_child) {
                                return pos.id === pos_child.id;
                            });
                        });
                    }
                    block_pos_edit.stop();
                } else {
                    block_pos_edit.stop();

                    NotifyService.Error($filter('translate')('POS isn\'t saved!') + '<br/>' + response.message);
                }

            }

            if (isFormValid(form)) {

                var post_data = angular.copy($scope.model.pos);

                post_data = cleanRequestData(post_data);
                post_data.public_title = post_data.public_title ? post_data.public_title[$rootScope.LANG] : '';
                post_data.public_description = post_data.public_description ? post_data.public_description[$rootScope.LANG] : '';
                post_data.loyalty_id = $scope.data.currentLoyalty.id;
                post_data.links = {};

                for (var i in $scope.data.loyaltyLinks) {
                    var l = $scope.data.loyaltyLinks[i];

                    if (l.used)
                        post_data.links[l.type] = l.url;
                }
                for (var i in post_data.categories) {
                    delete post_data.categories[i].title;
                    delete post_data.categories[i].image_url;
                }
                if (remove) {
                    $scope.model.pos_children = $scope.model.pos_children.filter(function (pos) {
                        return child_pos.id !== pos.id;
                    });
                } else {
                    $scope.model.pos_children.push(child_pos);
                }
                var pos_child_data = {

                    order_processing: {
                        children: $scope.model.pos_children,
                        parents: [
                            post_data
                        ]

                    }

                };
                POSService.ChangeReferences(post_data.id, pos_child_data, handleResult);

            } else {
                block_pos_edit.stop();
            }
        }

        $scope.onAddPhone = function () {
            if (!$scope.model.pos.phones)
                $scope.model.pos.phones = [];

            $scope.model.pos.phones.push({'number': ''});
        };

        $scope.onRemovePhone = function (index) {
            $scope.model.pos.phones.splice(index, 1);
        };

        $scope.isShowButton = function (btn) {
            if (!$scope.model.pos) {
                $scope.model.pos = {catalog_publication_state: 'none'};
                initMap();
            }

            switch (btn) {
                case 'save':
                    return ['none', 'rejected'].indexOf($scope.model.pos.catalog_publication_state) != -1;
                case 'publish':
                    return ['none', 'rejected'].indexOf($scope.model.pos.catalog_publication_state) != -1;
                case 'unpublish':
                    return ['requested', 'allowed'].indexOf($scope.model.pos.catalog_publication_state) != -1;
                case 'save-and-publish':
                    return ['allowed'].indexOf($scope.model.pos.catalog_publication_state) != -1;
            }

            return true;
        };

        $scope.handleFileSelect = function (evt) {
            var file = evt.currentTarget.files[0],
                reader = new FileReader();

            var imageType = file.type,
                isPng = imageType === 'image/png';

            reader.onload = function (e) {
                var img = new Image();

                img.onload = function () {
                    var canvas = document.getElementById('file-canvas'),
                        ctx = canvas.getContext('2d'),
                        width = img.width,
                        height = img.height,
                        maxAllowedSize = 2 * 1024 * 1024;

                    canvas.width = width;
                    canvas.height = height;
                    ctx.clearRect(0, 0, width, height);
                    ctx.drawImage(img, 0, 0, width, height);

                    var resizedImageDataUrl;

                    if (isPng) {
                        resizedImageDataUrl = canvas.toDataURL('image/png');
                    } else {
                        resizedImageDataUrl = canvas.toDataURL('image/jpeg', 1);
                    }

                    if (resizedImageDataUrl.length > maxAllowedSize) {
                        var scale = 0.95,
                            quality = 1;

                        do {
                            width = Math.round(img.width * scale);
                            height = Math.round(img.height * scale);

                            canvas.width = width;
                            canvas.height = height;
                            ctx.clearRect(0, 0, width, height);
                            ctx.drawImage(img, 0, 0, width, height);

                            if (isPng) {
                                resizedImageDataUrl = canvas.toDataURL('image/png');
                            } else {
                                quality = Math.max(quality - 0.05, 0.1);
                                resizedImageDataUrl = canvas.toDataURL('image/jpeg', quality);
                            }

                            scale -= 0.05;
                        } while (
                            resizedImageDataUrl.length > maxAllowedSize &&
                            width > 50 && height > 50
                            );
                    }
                    $scope.$apply(function () {
                        $scope.data.posImage.cropped = '';
                        $scope.data.posImage.loading = false;
                        $scope.data.posImage.new = true;
                        $scope.data.posImage.src = resizedImageDataUrl;
                    });
                };
                img.src = e.target.result;
            };

            reader.readAsDataURL(file);
        };

        $scope.initImgCrop = function () {
            var file = angular.element(document.getElementById('posImage'));
            file.on('change', $scope.handleFileSelect);
        };
        $scope.removeNotificationEmail = function (index) {
            $scope.model.posOnlineStore.notification_emails.splice(index, 1);
        };
        $scope.addNotificationEmail = function () {
            if (!$scope.model.posOnlineStore.notification_emails) {
                $scope.model.posOnlineStore.notification_emails = [];
            }

            $scope.model.posOnlineStore.notification_emails.push('');

        };

        $scope.emptyNotificationEmailList = function () {
            $scope.model.posOnlineStore.notification_emails = [];
        };

        $rootScope.$watch('LOYALTIES', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.loyaltiesList = angular.copy($rootScope.LOYALTIES);

                if ($scope._pageMode === 'show')
                    $scope.data.loyaltiesList.unshift({
                        title: $filter('translate')('All loyalties'),
                        id: '0',
                        active: 1
                    });

                var saved_loyalty;

                if ($rootScope.ENV.filters.global_filter && $rootScope.ENV.filters.global_filter.loyalty_id !== '0') {
                    $scope.data.currentLoyalty = $scope.data.loyaltiesList.find(function (filterItem) {
                        if (filterItem.id === $rootScope.ENV.filters.global_filter.loyalty_id) {
                            return true;
                        }
                    });
                } else {
                    var index;

                    switch ($scope._pageMode) {
                        case 'show':
                            for (var i in $scope.data.loyaltiesList)
                                if ($scope.data.loyaltiesList[i].id === '0')
                                    $scope.data.currentLoyalty = $scope.data.loyaltiesList[i];
                            break;
                        case 'create':
                            $scope.data.currentLoyalty = getFirstActive($scope.data.loyaltiesList);
                            break;
                        case 'edit':
                            if ($scope.model.pos)
                                $scope.data.currentLoyalty = itemByIndex($scope.data.loyaltiesList, $scope.model.pos.loyalty_id);
                    }
                }
            }
        });

        $scope.$watch('data.currentLoyalty', function (newValue, oldValue) {
            if (newValue) {
                getFeedbackSources(newValue.id);
                switch ($scope._pageMode) {
                    case 'show':
                        _doShow();

                        $rootScope.ENV.filters.pos_list = {
                            loyalty_id: newValue.id
                        };

                        $rootScope.ENV.filters.global_filter = {loyalty_id: newValue.id};
                        $rootScope.storeENV();
                        break;
                    case 'create':
                        _doCreate();
                        break;
                }
            }
        }, true);

        $rootScope.$watchCollection('[COUNTRIES[LANG],TIMEZONES[LANG]]', function (newCollection, oldCollection, scope) {
            if (newCollection[0]) {
                $scope.data.countriesList = angular.copy($rootScope.COUNTRIES[$rootScope.LANG]);
            }
            if (newCollection[1]) {
                $scope.data.timezonesList = angular.copy($rootScope.TIMEZONES[$rootScope.LANG]);
            }
            if (newCollection[0] && newCollection[1] && $scope._pageMode === 'create') {
                if ($scope.model.pos) {
                    var pos_country = itemByIndex($scope.data.countriesList, $scope.model.pos.country);
                    if (pos_country) {
                        $scope.model.pos.time_zone = itemByIndex($scope.data.timezonesList, pos_country.time_zone).id;
                    }
                }
            }
        }, true);

        $scope.$watch('data.currentTab', function (newValue, oldValue) {
            if (newValue === 'publish') {

                $scope.data.showMap = false;
                $timeout(function () {
                    $scope.data.showMap = true;
                });
            }
        });

    }
})();
